import script from "./RateLimitOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./RateLimitOverlay.vue?vue&type=script&setup=true&lang=js"

import "./RateLimitOverlay.vue?vue&type=style&index=0&id=9dfe7006&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dfe7006"]])

export default __exports__